export const REQUEST_STATUS = {
  HTTP_OK: 200,
  HTTP_SUCCESS: 201,
  HTTP_FORBIDDEN: 403,
  HTTP_NOT_FOUND: 404,
  HTTP_CONFLICT: 409,
  HTTP_TOO_MANY_REQUESTS: 429,
  HTTP_SERVICE_UNAVAILABLE: 503,
} as const;

export type RequestStatus = (typeof REQUEST_STATUS)[keyof typeof REQUEST_STATUS];

export const NO_ACCESS_STATUS = {
  HTTP_NOT_AUTHORIZED: '401',
  HTTP_NOT_FOUND: '404',
} as const;

export type NoAccessStatus = (typeof NO_ACCESS_STATUS)[keyof typeof NO_ACCESS_STATUS];
